import type { TeoPDF } from '../TeoPDF';
import type { Bounds, Position } from './types';

export function addArc(
  this: TeoPDF,
  center: Position,
  {
    radius = 0,
    lineWidth,
    color,
    rotation = 0,
    lengthDeg = 360,
  }: {
    lineWidth?: number;
    radius?: number;
    color?: string;
    rotation?: number;
    lengthDeg?: number;
  },
) {
  const rad = 2 * (Math.min(lengthDeg, 360) / 360);
  const circle = this.doc.circle(center.x, center.y, radius);
  if (lineWidth) {
    circle.lineWidth(lineWidth);
  }

  circle
    .dash(radius * Math.PI * rad, {
      space: radius * Math.PI * (2 - rad),
      phase: (Math.PI * radius * 2 * rotation) / 360,
    })
    .stroke(color)
    .undash();

  return this;
}

export function addRect(this: TeoPDF, dimension: Bounds, color?: string) {
  this.doc.rect(dimension.x, dimension.y, dimension.width, dimension.height).fill(color);
  return this;
}
